module.exports = __webpack_public_path__ + "static/media/1004592.1581cd72.png";